import type { StatusColor } from '~/types'

export enum ProductQuestionStatus {
  AwaitingAnswer = '1',
  AwaitingModeration = '2',
  Published = '3',
  NotPublished = '4'
}

const { AwaitingAnswer, AwaitingModeration, NotPublished, Published } = ProductQuestionStatus

const colorMapping: Map<ProductQuestionStatus, StatusColor> = new Map([
  [AwaitingAnswer, 'yellow'],
  [AwaitingModeration, 'orange'],
  [Published, 'blue'],
  [NotPublished, 'gray']
])

const nameMapping = new Map([
  [AwaitingAnswer, 'Ожидает ответа'],
  [AwaitingModeration, 'Ожидает проверки'],
  [Published, 'Опубликован'],
  [NotPublished, 'Не опубликован']
])

export const ProductQuestionStatusUtils = {
  sortedMembers: [AwaitingAnswer, AwaitingModeration, Published, NotPublished],
  getColor: (x: ProductQuestionStatus): StatusColor => colorMapping.get(x)!,
  getName: (x: ProductQuestionStatus): string => nameMapping.get(x)!
}
